import { render, staticRenderFns } from "./CalendarioEstudio.vue?vue&type=template&id=4f6874b4&"
import script from "./CalendarioEstudio.vue?vue&type=script&lang=js&"
export * from "./CalendarioEstudio.vue?vue&type=script&lang=js&"
import style0 from "./CalendarioEstudio.vue?vue&type=style&index=0&id=4f6874b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports